import React from 'react';
import { useSelector } from 'react-redux';
import { MeterGroup as PrimeMeterGroup} from 'primereact/metergroup';

import { checkPermissions } from '../utils';
import PermDetailsWrapper from '../common/PermDetailsWrapper';


const MeterGroup = (props) => {
    const userDetails = useSelector(state => state.userDetails)

    const values = props.values? props.values : ""
    const style = props.style ? props.style : {}

    const permissions = props.permissions ? props.permissions : []
    const permParameters = props.permParameters ? props.permParameters : {}

    let disabled = false 
    let isPermitted = false
    let permittedCompanyRoleIds = []
    let permittedExceptionUserRoleIds = []
    let permittedExceptionNegitiveUserRoleIds = []

    if(permissions.length){
        const permParams = {
            reqPermActionIds: permissions,
            permParameters: permParameters,
            activeCompanyRoleId: userDetails.activeCompanyRoleId,
            userRoleId: userDetails.activeRoleId,
            permExceptions: userDetails.permExceptions,
            permGeo: userDetails.permGeo,
            permActions: userDetails.permActions,
            permRoles: userDetails.permRoles,
            companyRoles: userDetails.companyDetails.companyRoles
        }

        const permissionDetails = checkPermissions(permParams)
        isPermitted = permissionDetails.isPermitted
        permittedCompanyRoleIds = permissionDetails.permittedCompanyRoleIds
        permittedExceptionUserRoleIds = permissionDetails.permittedExceptionUserRoleIds
        permittedExceptionNegitiveUserRoleIds = permissionDetails.permittedExceptionNegitiveUserRoleIds

        if(!isPermitted){
            disabled = true
        }
    }

    if(props.disabled){
        disabled = true
    }
    
    const handleOnClick = (e) => {
        if (props.onClick && !disabled) {
            props.onClick(e)
        }
    }

    const renderPrimeMeterGroup = () => (
        <div className="flex justify-content-center">
            <PrimeMeterGroup 
                className={!disabled && `lift-box`}
                disabled={disabled}
                values={values} 
                style={{style}} 
                onClick={handleOnClick}
            />
        </div>
    )

    return (
        <PermDetailsWrapper
            displayComponent={renderPrimeMeterGroup()}
            uniqueId={props.labelText}
            permissions={permissions}
            permittedCompanyRoleIds={permittedCompanyRoleIds}
            permittedExceptionUserRoleIds={permittedExceptionUserRoleIds}
            permittedExceptionNegitiveUserRoleIds={permittedExceptionNegitiveUserRoleIds}
            visible={!props.disabled && !isPermitted}
        />
    )
}

export default MeterGroup;

